import styled, { css, keyframes } from 'styled-components';

import { TransientProps } from '@common/types';
import { Input } from '@components';

import { ContentWrapper } from '../styles';

type ContainerProps = TransientProps<{ disabled: boolean; hide: boolean }>;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.form<ContainerProps>`
  ${({ $disabled: isDisabled, $hide: shouldHide }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 1rem 0;
    transition: 500ms ease-in-out;

    ${isDisabled &&
    css`
      opacity: 0;
      pointer-events: none;
      user-select: none;
    `}

    ${shouldHide &&
    css`
      display: none;
    `}
  `}
`;

export const ChatContentWrapper = styled(ContentWrapper)`
  display: flex;
`;

export const ChatInput = styled(Input)`
  height: 3.25rem;
  max-width: calc(100% - 2rem);
  margin: 0 1rem;

  > svg {
    margin: 0 0 0 0.5rem;
  }

  input {
    font-size: 0.875rem;
  }
`;

export const ReplyBanner = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    margin: 0 1rem 0.5rem;
    background: color-mix(
      in srgb,
      ${theme.colors.brand.primary.default} 7%,
      transparent
    );
    border-left: 2px solid ${theme.colors.brand.primary.default};
    border-radius: 0 0.375rem 0.375rem 0;
    animation: ${slideUp} 0.2s ease-out;
    flex-shrink: 0;
  `}
`;

export const ReplyBannerContent = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-width: 0;

    span {
      display: block;
      font-size: 0.6875rem;
      color: ${theme.colors.brand.primary.default};
      font-weight: 600;
      margin-bottom: 0.0625rem;
    }

    p {
      font-size: 0.6875rem;
      color: ${theme.colors.foreground[60]};
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `}
`;

export const ReplyBannerClose = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    padding: 0.125rem;
    cursor: pointer;
    color: ${theme.colors.foreground[40]};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    transition: color 150ms;

    &:hover {
      color: ${theme.colors.foreground[80]};
    }
  `}
`;
